export const getModalState = (state) => state.refund.modal;
